export default __webpack_public_path__ + "static/media/carousel-placeholder.52b29200.png";